module.exports = __webpack_public_path__ + "static/media/focus-active.8227f14d.png";